import type { GuidanceSummaryV2 } from 'common/types/approvals';

import { View, ViewRight } from 'common/types/view';
import { isStory } from 'common/views/view_types';
import { hasRights } from 'common/views/has_rights';
import { AssetStatus, assetStatusFor } from 'common/views/asset_status';
import FeatureFlags from 'common/feature_flags';

/**
 * Determines whether or not the current user can schedule send on published story.
 *
 *
 * @param view View to check for schedule send privileges
 * @param approvalsGuidance Approvals guidance summary
 * @returns Whether or not the current user can do scheduled send on published story
 */
const currentUserCanScheduleSend = (view: View, approvalsGuidance: GuidanceSummaryV2) => {
  // Users with read access to a published story can schedule send report.

  return (
    isStory(view) &&
    assetStatusFor(view, approvalsGuidance) === AssetStatus.Published &&
    FeatureFlags.valueOrDefault('enable_report_scheduled_delivery', false) &&
    hasRights(view, ViewRight.Read)
  );
};

export default currentUserCanScheduleSend;
